import $ from 'jquery';
import rimg from '@pixelunion/rimg-shopify';
import { classes, selectors } from '../Constants';
import Modal from '../Modal';
import layout from '../Layout';
import ProductLayout from '../components/ProductLayout';
import CartRequests from './cart/CartRequests';

export default class QuickShop {
  constructor(options) {
    this.el = options.el || null;
    this.productUrl = options.url || null;
    this.productID = options.id || null;
    this.trigger = options.trigger || null;
    this.cartRequests = new CartRequests();

    if (
      !this.el
      || !this.productUrl
      || !this.productID
      || !this.trigger
    ) {
      return console.warn('Unable to initiate QuickShop.js');
    }

    this.$window = $(window);
    this.$document = $(document);
    this.$trigger = $(this.trigger);

    // Build up selectors
    this.selectorTag = `${selectors.product.quickshop.selectorAttr}="${this.productID}"`;
    this.selector = `[${this.selectorTag}]`;

    // Default out globals
    this.quickShopData = null;
    this.quickShopEl = null;
    this.productEl = null;
    this.$formAtc = null;
    this.$errorMessage = $(`<div ${selectors.product.quickshop.errorAttr} class="${classes.product.quickshop.error}"/>`);
    this.data = null;
    this.modal = null;
    this.priceManager = null;

    this._handleBeforeShow = this._handleBeforeShow.bind(this);
    this._handleOpen = this._handleOpen.bind(this);
    this._handleClose = this._handleClose.bind(this);
    this._handleError = this._handleError.bind(this);
    this._resetError = this._resetError.bind(this);
    this._onATCSubmit = this._onATCSubmit.bind(this);
    this._onATCSuccess = this._onATCSuccess.bind(this);

    this._onBreakpointChange = this._onBreakpointChange.bind(this);
    layout.onBreakpointChange(this._onBreakpointChange);
  }

  open() {
    this.trigger.setAttribute('disabled', 'disabled');

    const injectQuickShopData = data => {
      if (this.quickShopEl) {
        // Remove any previous QuickShop markup
        this.quickShopEl.parentNode.removeChild(this.quickShopEl);
      }

      const wrapper = document.createElement('div');
      wrapper.classList.add(classes.product.quickshop.wrapper);
      wrapper.setAttribute(selectors.product.quickshop.selectorAttr, this.productID);
      wrapper.innerHTML = data;

      try {
        this.data = JSON.parse(wrapper.querySelector(selectors.product.quickshop.data).innerText);
      } catch (error) {
        return console.warn(`Quickshop: invalid quickshop data found. ${error.message}`);
      }

      this.el.appendChild(wrapper);

      this.quickShopEl = this.el.querySelector(this.selector);
      // Bind productEl to node of contents, which gets moved into Modal
      this.productEl = this.el.querySelector(selectors.product.quickshop.contents);

      rimg.watch(this.quickShopEl);
      this._openQuickShop();
    };

    if (!this.quickShopData) {
      $.ajax({
        url: this.productUrl,
        data: 'view=quickshop',
        dataType: 'html',
        success: data => {
          this.quickShopData = data;
          injectQuickShopData(data)
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.warn(`Unable to Quickshop with error: ${errorThrown}`);
        },
      });
    } else {
      injectQuickShopData(this.quickShopData);
    }
  }

  unload() {
    this._handleClose();
    layout.offBreakpointChange(this._onBreakpointChange);
  }

  _openQuickShop() {
    const modalCallbacks = {
      onBeforeShow: this._handleBeforeShow,
      onOpen: this._handleOpen,
      onClose: this._handleClose,
    };

    this.modal = new Modal(modalCallbacks);
    this.modal.open(this.selector, 'quickshop');
  }

  _handleBeforeShow() {
    // Set object fit for IE11
    this.$document.trigger('check-object-fit', {
      el: this.productEl,
    });

    // Set up error handling
    this.$formAtc = $(this.productEl.querySelector(selectors.product.form.atc));

    // Clear errors on variant switch
    this.$window.on('shopify-variants:switch-variant.product-quickshop', this._resetError);
  }

  _handleError(error) {
    this.$errorMessage.text(error.responseJSON.description);
    this.$formAtc.prepend(this.$errorMessage);
  }

  _handleOpen($modal) {
    // Instantiate Product JS
    this.productLayout = new ProductLayout({
      el: this.productEl,
      moneyFormat: this.data.money_format,
      product: this.data.product,
      variantAvailable: this.data.variant_available,
      settings: this.data.settings,
      textStrings: this.data.text_strings,
      selectedVariantId: this.data.selected_variant_id,
      onATCSubmit: this._onATCSubmit,
      onATCSuccess: this._onATCSuccess,
    });

    $modal.find('a:visible:first').eq(0).focus();

    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
  }

  _handleClose() {
    if (this.modal) {
      rimg.unwatch(this.quickShopEl);
      this.productLayout.unload();
      this.modal.unload();
      this.$trigger.removeAttr('disabled').focus();
      this.$window.off('shopify-variants:switch-variant.product-quickshop');
    }
  }

  _onBreakpointChange() {
    if (layout.isBreakpoint('XS') || layout.isBreakpoint('S')) {
      this._handleClose();
    }
  }

  /**
   * Actions to perform when submitting ATC to Shopify
   *
   * @private
   */
  _onATCSubmit() {
    this._resetError();

    this.cartRequests.setHandlers({
      onError: this._handleError,
    });
  }

  _resetError() {
    if (this.$errorMessage.length) {
      this.$errorMessage.remove();
    }
  }

  /**
   * Actions to perform on a successful ATC
   * @private
   */
  _onATCSuccess() {
    this.cartRequests.restoreHandlers();
  }
}
